import React from 'react';
import { ActivityIcon, AlertTriangleIcon, CheckCircle2Icon, ShieldAlertIcon, TrendingUpIcon, TrendingDownIcon, BarChart3Icon } from 'lucide-react';
import { StatusBadge } from '../components/ui/StatusBadge';
export function MonitoringPage() {
  return <div className="flex flex-col pb-12" data-id="element-844">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4" data-id="element-845">
        <div data-id="element-846">
          <h1 className="text-3xl font-bold mb-1 flex items-center gap-2" data-id="element-847">
            <ActivityIcon className="w-8 h-8 text-primary" data-id="element-848" />
            Billing Observability
          </h1>
          <p className="text-muted-foreground" data-id="element-849">
            Real-time webhook health, revenue metrics, and configuration drift
            alerts.
          </p>
        </div>
        <div className="bg-pk-info-light text-pk-info-dark px-3 py-1.5 rounded-full text-sm font-medium border border-pk-info/20 flex items-center gap-2" data-id="element-850">
          <ActivityIcon className="w-4 h-4" data-id="element-851" />
          Active Plan: $19/mo
        </div>
      </div>

      {/* Billing Metrics */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-852">
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-853">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-854">
            MRR
          </div>
          <div className="flex items-end gap-2" data-id="element-855">
            <div className="text-3xl font-bold" data-id="element-856">$4,280</div>
            <div className="flex items-center text-xs font-medium text-pk-success mb-1" data-id="element-857">
              <TrendingUpIcon className="w-3 h-3 mr-0.5" data-id="element-858" /> +12%
            </div>
          </div>
        </div>
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-859">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-860">
            Active Subscriptions
          </div>
          <div className="text-3xl font-bold" data-id="element-861">142</div>
        </div>
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-862">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-863">
            Churn Rate
          </div>
          <div className="flex items-end gap-2" data-id="element-864">
            <div className="text-3xl font-bold" data-id="element-865">2.1%</div>
            <div className="flex items-center text-xs font-medium text-pk-success mb-1" data-id="element-866">
              <TrendingDownIcon className="w-3 h-3 mr-0.5" data-id="element-867" /> -0.4%
            </div>
          </div>
        </div>
        <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-868">
          <div className="text-sm font-medium text-muted-foreground mb-2" data-id="element-869">
            Webhook Success
          </div>
          <div className="text-3xl font-bold text-pk-success" data-id="element-870">99.7%</div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-10" data-id="element-871">
        {/* Latency & Volume Charts */}
        <div className="md:col-span-1 space-y-6" data-id="element-872">
          <div className="bg-card border border-border rounded-xl p-6 shadow-sm" data-id="element-873">
            <h3 className="font-bold text-sm uppercase tracking-wider text-muted-foreground mb-4 flex items-center gap-2" data-id="element-874">
              <BarChart3Icon className="w-4 h-4" data-id="element-875" />
              Event Volume (7d)
            </h3>
            <div className="flex items-end gap-1 h-24 mt-4" data-id="element-876">
              {[40, 65, 45, 80, 55, 90, 70].map((h, i) => <div key={i} className="flex-1 bg-primary/20 hover:bg-primary transition-colors rounded-t-sm relative group" style={{
              height: `${h}%`
            }} data-id="element-877">
                  <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-foreground text-background text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-878">
                    {h * 12}
                  </div>
                </div>)}
            </div>
            <div className="flex justify-between text-xs text-muted-foreground mt-2" data-id="element-879">
              <span data-id="element-880">Mon</span>
              <span data-id="element-881">Sun</span>
            </div>
          </div>

          <div className="bg-card border border-border rounded-xl p-6 shadow-sm" data-id="element-882">
            <h3 className="font-bold text-sm uppercase tracking-wider text-muted-foreground mb-4" data-id="element-883">
              Avg Latency
            </h3>
            <div className="text-3xl font-bold mb-1" data-id="element-884">
              124
              <span className="text-lg text-muted-foreground font-normal" data-id="element-885">
                ms
              </span>
            </div>
            <p className="text-xs text-muted-foreground" data-id="element-886">P95: 210ms</p>
          </div>
        </div>

        {/* Recent Webhook Events Log */}
        <div className="md:col-span-2 bg-card border border-border rounded-xl shadow-sm overflow-hidden flex flex-col" data-id="element-887">
          <div className="px-6 py-4 border-b border-border flex justify-between items-center bg-muted/30" data-id="element-888">
            <h3 className="font-bold text-sm uppercase tracking-wider text-muted-foreground" data-id="element-889">
              Recent Webhook Events
            </h3>
            <button className="text-xs font-medium text-primary hover:underline" data-id="element-890">
              View Logs
            </button>
          </div>
          <div className="overflow-x-auto flex-1" data-id="element-891">
            <table className="w-full text-sm text-left" data-id="element-892">
              <thead className="text-xs text-muted-foreground uppercase border-b border-border" data-id="element-893">
                <tr data-id="element-894">
                  <th className="px-6 py-3 font-medium" data-id="element-895">Event ID</th>
                  <th className="px-6 py-3 font-medium" data-id="element-896">Type</th>
                  <th className="px-6 py-3 font-medium" data-id="element-897">Status</th>
                  <th className="px-6 py-3 font-medium text-right" data-id="element-898">Time</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border font-mono text-xs" data-id="element-899">
                <tr className="hover:bg-muted/30 transition-colors" data-id="element-900">
                  <td className="px-6 py-3 text-muted-foreground" data-id="element-901">
                    evt_1N2M3L
                  </td>
                  <td className="px-6 py-3 font-medium text-foreground" data-id="element-902">
                    customer.subscription.created
                  </td>
                  <td className="px-6 py-3" data-id="element-903">
                    <StatusBadge status="success" label="200 OK" className="!text-[10px] !py-0" data-id="element-904" />
                  </td>
                  <td className="px-6 py-3 text-right text-muted-foreground" data-id="element-905">
                    2m ago
                  </td>
                </tr>
                <tr className="hover:bg-muted/30 transition-colors" data-id="element-906">
                  <td className="px-6 py-3 text-muted-foreground" data-id="element-907">
                    evt_9X8Y7Z
                  </td>
                  <td className="px-6 py-3 font-medium text-foreground" data-id="element-908">
                    invoice.payment_succeeded
                  </td>
                  <td className="px-6 py-3" data-id="element-909">
                    <StatusBadge status="success" label="200 OK" className="!text-[10px] !py-0" data-id="element-910" />
                  </td>
                  <td className="px-6 py-3 text-right text-muted-foreground" data-id="element-911">
                    15m ago
                  </td>
                </tr>
                <tr className="hover:bg-muted/30 transition-colors bg-pk-error-light/10" data-id="element-912">
                  <td className="px-6 py-3 text-muted-foreground" data-id="element-913">
                    evt_4A5B6C
                  </td>
                  <td className="px-6 py-3 font-medium text-foreground" data-id="element-914">
                    checkout.session.completed
                  </td>
                  <td className="px-6 py-3" data-id="element-915">
                    <StatusBadge status="error" label="500 ERR" className="!text-[10px] !py-0" data-id="element-916" />
                  </td>
                  <td className="px-6 py-3 text-right text-muted-foreground" data-id="element-917">
                    1h ago
                  </td>
                </tr>
                <tr className="hover:bg-muted/30 transition-colors" data-id="element-918">
                  <td className="px-6 py-3 text-muted-foreground" data-id="element-919">
                    evt_7D8E9F
                  </td>
                  <td className="px-6 py-3 font-medium text-foreground" data-id="element-920">
                    customer.created
                  </td>
                  <td className="px-6 py-3" data-id="element-921">
                    <StatusBadge status="success" label="200 OK" className="!text-[10px] !py-0" data-id="element-922" />
                  </td>
                  <td className="px-6 py-3 text-right text-muted-foreground" data-id="element-923">
                    1h ago
                  </td>
                </tr>
                <tr className="hover:bg-muted/30 transition-colors" data-id="element-924">
                  <td className="px-6 py-3 text-muted-foreground" data-id="element-925">
                    evt_2G3H4I
                  </td>
                  <td className="px-6 py-3 font-medium text-foreground" data-id="element-926">
                    customer.subscription.updated
                  </td>
                  <td className="px-6 py-3" data-id="element-927">
                    <StatusBadge status="success" label="200 OK" className="!text-[10px] !py-0" data-id="element-928" />
                  </td>
                  <td className="px-6 py-3 text-right text-muted-foreground" data-id="element-929">
                    3h ago
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Monitored Accounts */}
      <h2 className="text-xl font-bold mb-4" data-id="element-930">Monitored Accounts</h2>
      <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-931">
        <div className="bg-card border border-border rounded-xl p-6 shadow-sm flex flex-col" data-id="element-932">
          <div className="flex justify-between items-start mb-6" data-id="element-933">
            <div data-id="element-934">
              <h3 className="font-bold text-lg" data-id="element-935">Acme SaaS</h3>
              <p className="text-sm text-muted-foreground" data-id="element-936">
                Last check: 2 min ago
              </p>
            </div>
            <div className="w-12 h-12 rounded-full border-4 border-pk-success flex items-center justify-center font-bold text-pk-success" data-id="element-937">
              94%
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 mt-auto" data-id="element-938">
            <div className="bg-pk-surface p-3 rounded-lg" data-id="element-939">
              <div className="text-xs text-muted-foreground mb-1" data-id="element-940">Webhooks</div>
              <StatusBadge status="success" label="Healthy" data-id="element-941" />
            </div>
            <div className="bg-pk-surface p-3 rounded-lg" data-id="element-942">
              <div className="text-xs text-muted-foreground mb-1" data-id="element-943">
                Config Drift
              </div>
              <StatusBadge status="warning" label="1 Alert" data-id="element-944" />
            </div>
          </div>
        </div>

        <div className="bg-card border border-border rounded-xl p-6 shadow-sm flex flex-col opacity-60 grayscale hover:grayscale-0 hover:opacity-100 transition-all cursor-pointer border-dashed" data-id="element-945">
          <div className="flex flex-col items-center justify-center h-full text-center py-4" data-id="element-946">
            <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-3" data-id="element-947">
              <ActivityIcon className="w-6 h-6 text-muted-foreground" data-id="element-948" />
            </div>
            <h3 className="font-medium mb-1" data-id="element-949">Add Account</h3>
            <p className="text-sm text-muted-foreground" data-id="element-950">
              +$9/mo per additional account
            </p>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-951">
        {/* Active Alerts */}
        <div data-id="element-952">
          <h2 className="text-xl font-bold mb-4 flex items-center gap-2" data-id="element-953">
            <ShieldAlertIcon className="w-5 h-5 text-pk-amber" data-id="element-954" />
            Active Alerts
          </h2>
          <div className="space-y-4" data-id="element-955">
            <div className="bg-card border border-pk-amber/30 rounded-xl p-5 shadow-sm relative overflow-hidden" data-id="element-956">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-pk-amber" data-id="element-957"></div>
              <div className="flex justify-between items-start mb-2" data-id="element-958">
                <h3 className="font-semibold text-pk-amber-dark" data-id="element-959">
                  Configuration Drift Detected
                </h3>
                <span className="text-xs text-muted-foreground" data-id="element-960">
                  2 hours ago
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-4" data-id="element-961">
                A price object (price_1N2M...) was modified directly in the
                Stripe dashboard, bypassing PayKit.
              </p>
              <div className="flex gap-3" data-id="element-962">
                <button className="text-xs font-medium bg-pk-amber text-white px-3 py-1.5 rounded hover:bg-pk-amber/90 transition-colors" data-id="element-963">
                  Review Change
                </button>
                <button className="text-xs font-medium text-muted-foreground hover:text-foreground px-3 py-1.5 transition-colors" data-id="element-964">
                  Dismiss
                </button>
              </div>
            </div>

            <div className="bg-card border border-border rounded-xl p-5 shadow-sm relative overflow-hidden" data-id="element-965">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-pk-success" data-id="element-966"></div>
              <div className="flex justify-between items-start mb-2" data-id="element-967">
                <h3 className="font-semibold" data-id="element-968">Webhook Delivery Restored</h3>
                <span className="text-xs text-muted-foreground" data-id="element-969">
                  5 hours ago
                </span>
              </div>
              <p className="text-sm text-muted-foreground" data-id="element-970">
                Endpoint /webhook is now returning 200 OK after 3 consecutive
                failures.
              </p>
            </div>
          </div>
        </div>

        {/* Recommendations */}
        <div data-id="element-971">
          <h2 className="text-xl font-bold mb-4 flex items-center gap-2" data-id="element-972">
            <CheckCircle2Icon className="w-5 h-5 text-pk-info" data-id="element-973" />
            Recommendations
          </h2>
          <div className="space-y-4" data-id="element-974">
            <div className="bg-card border border-border rounded-xl p-5 shadow-sm" data-id="element-975">
              <h3 className="font-semibold mb-2" data-id="element-976">Enable Automatic Tax</h3>
              <p className="text-sm text-muted-foreground mb-4" data-id="element-977">
                Stripe recently updated their tax module. Based on your volume,
                enabling Stripe Tax could save you compliance headaches.
              </p>
              <button className="text-xs font-medium bg-muted text-foreground px-3 py-1.5 rounded hover:bg-muted/80 transition-colors" data-id="element-978">
                View Setup Guide
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}